export default function getLastMonthName(): string {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);

  // Format the date to return the month name only
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    // year: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export function getTwoMonthsAgoName(): string {
  const date = new Date();
  date.setMonth(date.getMonth() - 2);

  // Format the date to return the month name only
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    // year: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

  // Function to convert abbreviated month name to full month name
  export const getFullMonthName = (abbreviatedMonth: string): string => {
    const monthMap: { [key: string]: string } = {
      'jan': 'January',
      'feb': 'February',
      'mar': 'March',
      'apr': 'April',
      'may': 'May',
      'jun': 'June',
      'jul': 'July',
      'aug': 'August',
      'sep': 'September',
      'oct': 'October',
      'nov': 'November',
      'dec': 'December'
    };
    
    const lowerCaseMonth = abbreviatedMonth?.toLowerCase().substring(0, 3);
    return monthMap[lowerCaseMonth] || abbreviatedMonth;
  };
